import {TableBody, TableCell, TableRow} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import InputText from '../../components/forms/InputText';

const EditListBusinessItem = ({users, editable, setUsers}) => {
  const updateEmail = (id, value) => {
    setUsers(prevState => {
      return [
        ...prevState.map((a, index) => {
          if (index === id) {
            return {...a, 'E-mail': value};
          }
          return a;
        }),
      ];
    });
  };

  const updateNome = (id, value) => {
    setUsers(prevState => {
      return [
        ...prevState.map((a, index) => {
          if (index === id) {
            return {...a, Nome: value};
          }
          return a;
        }),
      ];
    });
  };

  const updateDepartament = (id, value) => {
    setUsers(prevState => {
      return [
        ...prevState.map((a, index) => {
          if (index === id) {
            return {...a, Departamento: value};
          }
          return a;
        }),
      ];
    });
  };

  const updatePhone = (id, value) => {
    setUsers(prevState => {
      return [
        ...prevState.map((a, index) => {
          if (index === id) {
            return {...a, Telefone: value};
          }
          return a;
        }),
      ];
    });
  };

  const updatePass = (id, value) => {
    setUsers(prevState => {
      return [
        ...prevState.map((a, index) => {
          if (index === id) {
            return {...a, 'Senha (Temporária)': value};
          }
          return a;
        }),
      ];
    });
  };

  const deleteItem = id => {
    const usersFilter = users.filter((item, index) => index != id);
    setUsers(usersFilter);
  };

  useEffect(() => {
    if (!editable) {
      const usersFilter = users.filter(
        item => item.CPF || item.NickName || item.Nome || item.Email,
      );
      setUsers(usersFilter);
    }
  }, [editable]);

  return (
    <TableBody>
      {users.length ? (
        editable ? (
          <>
            {users.map((user, index) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>
                  <InputText
                    label=""
                    value={users[index]['E-mail']}
                    onChange={e =>
                      updateEmail(index, e.target.value.toString())
                    }
                  />
                </TableCell>
                <TableCell>
                  <InputText
                    label=""
                    value={users[index].Nome}
                    onChange={e => updateNome(index, e.target.value.toString())}
                  />
                </TableCell>
                <TableCell>
                  <InputText
                    label=""
                    value={users[index].Departamento}
                    onChange={e =>
                      updateDepartament(index, e.target.value.toString())
                    }
                  />
                </TableCell>
                <TableCell>
                  <InputText
                    label=""
                    value={users[index].Telefone}
                    onChange={e =>
                      updatePhone(index, e.target.value.toString())
                    }
                  />
                </TableCell>
                <TableCell>
                  <span className="badge bg-warning text-dark">
                    <InputText
                      label=""
                      value={users[index]['Senha (Temporária)']}
                      onChange={e =>
                        updatePass(index, e.target.value.toString())
                      }
                    />
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </>
        ) : (
          users.map((user, index) => (
            <TableRow key={index}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{user['E-mail']}</TableCell>
              <TableCell>{user.Nome}</TableCell>
              <TableCell>{user.Departamento}</TableCell>
              <TableCell>{user.Telefone}</TableCell>
              <TableCell>
                <span className="badge bg-warning text-dark">
                  {user['Senha (Temporária)']}
                </span>
              </TableCell>
              <TableCell
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => deleteItem(index)}>
                <DeleteIcon />
              </TableCell>
            </TableRow>
          ))
        )
      ) : (
        <TableRow>
          <td colSpan="5" className="text-center">
            Sem dados.
          </td>
        </TableRow>
      )}
    </TableBody>
  );
};

export default EditListBusinessItem;
